import PracticeCourseAPI from '@/apis/business/student/practice-course-api.js'
import SelfLearningAPI from '@/apis/business/MISAStore/self-learning-api.js'
export default {
  namespaced: true,

  state: {
    selfLearningCourses: [],
    relatedCourses: [],
    selfLearning: {},
    isBuyCourse: false,
    canDoFree: true,
    isUpDoFree: false,
    courseDetailResult: {}, // kết quả bài làm
    itemActive: 1,
    wayCheckResultActive: 0, // cách kiểm tra kết quả bài làm
    isSetup: false
  },

  getters: {},

  mutations: {
    /**
     * set giá trị Có đang nhấn thiết lập để hiển thị màn chọn theme và cách thức làm bài không
     * */
    setIsSetup (state, data) {
      state.isSetup = data
    },
    /**
     * set giá trị chọn cách kiểm tra bài làm CTH
     * @param {*} state
     * @param {*} param
     */
    setWayCheckResultActive (state, param) {
      state.wayCheckResultActive = param
    },
    // set giá trị danh sách bài tập
    setSelfLearningCourses (state, data) {
      state.selfLearningCourses = data
    },

    // set giá trị đánh dấu đã mua khóa học hay chưa
    setIsBuyCourse (state, data) {
      state.isBuyCourse = data
    },

    // set giá trị học liệu liên quan
    setRelatedCourses (state, data) {
      state.relatedCourses = data
    },

    /**
     * Thông tin Con Tự Học
     * @param {*} state
     * @param {*} param
     */
    setSelfLearning (state, param) {
      state.selfLearning = param
    },
    // kết quả bài làm
    setCourseDetailResult (state, param) {
      state.courseDetailResult = param
    },
    // Có thể làm thử bài hay không
    setCanDoFree (state, param) {
      state.canDoFree = param
    },

    // Đã cộng số lượt làm thử lên hay chưa
    setIsUpDoFree (state, param) {
      state.isUpDoFree = param
    },
    // set giá trị item active trong màn chi tiết kháo học
    setItemActive (state, param) {
      state.itemActive = param
    }

  },

  actions: {
    async getSelfLearningCourses (context, params) {
      return new Promise((resolve, reject) => {
        SelfLearningAPI.getAsync(`self-learning-courses?partnerID=${params}`)
          .then((res) => {
            if (res && res.Data) {
              const data = res.Data
              context.commit(
                'setSelfLearningCourses', data

              )
              resolve(data)
            } else {
              resolve(false)
            }
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    submitExerciseSelfLearning (context, params) {
      return new Promise((resolve, reject) => {
        SelfLearningAPI.postAsync('submit-exercise-cth', params)
          .then((res) => {
            resolve(res.Data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    async getCourseDetailResult (context, params) {
      return await new Promise((resolve, reject) => {
        SelfLearningAPI.getAsync(`result-course?courseDetailID=${params}`)
          .then((res) => {
            if (res && res.Data) {
              const data = res.Data
              context.commit(
                'setCourseDetailResult', data

              )
              resolve(data)
            } else {
              resolve(false)
            }
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    /**
     * @description Lấy học liệu liên quan
     * @author VHSON
     */
    getRelatedCourse (context, param) {
      return new Promise((resolve, reject) => {
        SelfLearningAPI.getAsync(`related?id=${param}`)
          .then((res) => {
            if (res && res.Data) {
              context.commit('setRelatedCourses', res.Data)
              resolve(res.Data)
            } else {
              resolve(false)
            }
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * @description Kiểm tra xem đã mua học liệu hay chưa?
     * @author VHSON
     */
    checkIsBuyCourse (context, param) {
      return new Promise((resolve, reject) => {
        PracticeCourseAPI.getAsync(`check-buy?id=${param}`)
          .then((res) => {
            if (res) {
              context.commit('setIsBuyCourse', res.Data)
              resolve(res.Data)
            } else {
              resolve(false)
            }
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * @description Kiểm tra xem trong ngày đã làm quá 3 lần chưa
     * @author VHSON
     */
    checkDoFreeExercise (context) {
      return new Promise((resolve, reject) => {
        SelfLearningAPI.getAsync('check-do-free')
          .then((res) => {
            if (res) {
              context.commit('setCanDoFree', res.Data)
              resolve(res.Data)
            } else {
              resolve(false)
            }
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * @description Khi học sinh làm bài thì insert bản ghi xuống db để đánh dấu( Mục đích: Validate không làm làm free quá 3 lần 1 ngày)
     * @author VHSON
     */
    doFreeExerciseSelfLearning (context) {
      return new Promise((resolve, reject) => {
        SelfLearningAPI.postAsync('do-free')
          .then((res) => {
            if (res && res.Data) {
              context.commit('setCanDoFree', res.Data)
              resolve(res.Data)
            } else {
              resolve(false)
            }
          })
          .catch((err) => {
            reject(err)
          })
      })
    }

  }
}
